<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text mb-1">
        {{ t('Пол врача', options) }}
      </div>
    </slot>
    <v-chip-group
      :value="doctorFiltersState.gender"
      column
      active-class="primary"
      @change="handleChangeChip"
    >
      <v-chip
        v-for="(chip, i) in genderChips"
        :key="i"
        :value="chip.value"
        :color="chip.value === doctorFiltersState.gender ? 'primary' : 'bg-primary'"
        :text-color="chip.value === doctorFiltersState.gender ? 'bg-gray-0' : 'primary'"
      >
        {{ t(chip.name, options) }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()

const genderChips: ({ name: string, value: Filters['gender'] })[] = [
  { name: 'Женский', value: 'F' },
  { name: 'Мужской', value: 'M' },
]

const handleChangeChip = (gender: Filters['gender']) => {
  filtersStore.updateUnsavedFilters({ gender })
  emit('input', {
    ...doctorFiltersState.value,
    gender,
  })
}
</script>
